import { useEffect } from 'react';

import { PRESETS_VIEWS_FEATURE_FLAG } from 'bringg-web/features/preset-views/utils';
import { useHasFeatureFlag } from 'bringg-web/utils/feature-flags';
import { presetViewsRoot } from 'bringg-web/features/preset-views/stores/data-providers/preset-views-root';

const usePresetViewsReady = () => {
	const isPresetViewsEnabled = useHasFeatureFlag(PRESETS_VIEWS_FEATURE_FLAG);

	useEffect(() => {
		if (isPresetViewsEnabled) {
			const { presetViewsViewStore } = presetViewsRoot.getStore();
			if (!presetViewsViewStore.allLoaded) {
				presetViewsViewStore.loadPresetsInfo();
			}
		}
	}, []);

	return {
		isPresetViewsEnabled: isPresetViewsEnabled,
		isPresetViewsFetched: isPresetViewsEnabled ? presetViewsRoot.getStore().presetViewsViewStore.allLoaded : false
	};
};

export default usePresetViewsReady;
